import React  from 'react'
import IconPositionEnum from '../Enums/IconPositionEnum';



class FigmaLink extends React.Component {
  static defaultProps = {
    className: '',
    value: 'default label',
    url: 'https://www.bareinternational.com/',
    iconName: 'fa-solid fa-circle',
    disabled: false,
    label: 'Default linklabel',
    iconPosition: IconPositionEnum.Left,
  };

  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  render() {
    let className = this.props.className ? this.props.className : 'primarylink';
    className = className + (this.props.disabled ? ' isDisabled' : '');

    return (
      <a
        className={className}
        href={this.props.url}
      >
        {this.props.iconPosition === IconPositionEnum.Left && <i className={this.props.iconName + ' mr-1'} />}
        {this.props.label}
        {this.props.iconPosition === IconPositionEnum.Right && <i className={this.props.iconName + ' ml-1'} />}
      </a>
    );
  }
}


export default FigmaLink;
